module.exports = __webpack_public_path__ + "static/media/Union_ph.783ecdc7.svg";